import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, editAreaReadyAction } from '../../reducers/actions';
import { ZoneService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_AREA_LOAD),
    switchMap(action =>
      ZoneService.getByAreaId(action.areaId, store).pipe(
        map(d =>  {
          return editAreaReadyAction(d);
        }),
        catchError(retryAuthentication(action$, 'epics/areas/editAreaLoad'))
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/areas/editAreaLoad.js